import { createContext } from 'react'

const ExpandableComponentContext = createContext({})

export default ExpandableComponentContext
